import { render, staticRenderFns } from "./FreePartnerCurations.vue?vue&type=template&id=e885de5a&"
import script from "./FreePartnerCurations.vue?vue&type=script&lang=js&"
export * from "./FreePartnerCurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FreeCurationsButtons: require('/opt/render/project/src/channels2022/src/components/free/FreeCurationsButtons.vue').default,FreeProducts: require('/opt/render/project/src/channels2022/src/components/free/FreeProducts.vue').default})
